var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7216 1.63282L7.67216 7.71985C7.30094 8.09338 6.69906 8.09338 6.32784 7.71985L0.278418 1.63282C-0.0928059 1.25929 -0.0928059 0.653678 0.278418 0.280147C0.64964 -0.0933832 1.25151 -0.0933832 1.62273 0.280147L7 5.69084L12.3773 0.280148C12.7485 -0.0933827 13.3504 -0.0933827 13.7216 0.280148C14.0928 0.653678 14.0928 1.25929 13.7216 1.63282Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrow);
export default __webpack_public_path__ + "static/media/DropDownArrow.4f7e6c7f12e1faaeb5671d5879d0d2a5.svg";
export { ForwardRef as ReactComponent };